import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

const EMPTY = { agents: [], apps: [] };

/**
 * useSidebarItems — ALL apps + agents across EVERY project the user can access
 * (owned + invited), in ONE request (GET /workspace/sidebar). Each row carries
 * its own projectId so the sidebar can link straight to the right project.
 *
 * Replaces the old per-project useApps(projectId)/useAgents(projectId) for the
 * pinned sidebar list — that reset whenever you switched projects. This is
 * account-wide and stable across project switches.
 */
export const useSidebarItems = () =>
  useQuery({
    queryKey: ['workspace', 'sidebar'],
    queryFn: async () => {
      const data = await api.get('/workspace/sidebar');
      return {
        agents: Array.isArray(data?.agents) ? data.agents : [],
        apps: Array.isArray(data?.apps) ? data.apps : [],
      };
    },
    staleTime: 60_000,
    placeholderData: EMPTY,
  });

export default useSidebarItems;
